import { render, staticRenderFns } from "./GanttChartSettings.vue?vue&type=template&id=a8ea73f8&scoped=true&"
import script from "./GanttChartSettings.vue?vue&type=script&lang=ts&"
export * from "./GanttChartSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ea73f8",
  null
  
)

export default component.exports